/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import { TableCell, TableRow } from '@material-ui/core';
import React from 'react';
import FolderIcon from '@material-ui/icons/Folder';
import useStyles from '../FOTableBodyStyle';
import EmptyTableWithFilter from '../../foEmptyTable/EmptyTableWithFilter';
import EmptyTable from '../../foEmptyTable/EmptyTable';

const EmptyCell = (props) => {
  const classes = useStyles();
  const { config, emptyTableData, anyAppliedFilters, setFilter, warningMessage, suggestion, error } = props;
  const colSpan = config.isExtraLargeOrBigger ? config.xlEmptyTableCol : config.emptyTableCol;

  const icon =
    emptyTableData && typeof emptyTableData === 'function' ? (
      emptyTableData()?.icon
    ) : (
      <FolderIcon color="default" className={classes.emptyTableIcon} />
    );

  return (
    <TableRow>
      <TableCell colSpan={colSpan}>
        {anyAppliedFilters ? (
          <EmptyTableWithFilter className={classes.emptyTable} icon={icon} onClick={() => setFilter([])} />
        ) : (
          <EmptyTable
            className={classes.emptyTable}
            icon={icon}
            warningMessage={warningMessage}
            suggestion={suggestion}
            error={error}
          />
        )}
      </TableCell>
    </TableRow>
  );
};

export default EmptyCell;
